module.exports = __webpack_public_path__ + "img/white_title_logo.15c2c2e1.svg";